export const  GA_FOR_SHAREPOINT = {
  open: {
    SharePoint: { eventKey: 'Share_Open', label: 'Share_Open', category: 'ADDIN', action: 'ADDIN_Share_Open'},
    OneDrive: { eventKey: 'One_Open', label: 'One_Open', category: 'ADDIN', action: 'ADDIN_One_Open'},
  },
  convert: {
    SharePoint: { eventKey: 'Share_Convert', label: 'Share_Convert', category: 'ADDIN', action: 'ADDIN_Share_Convert'},
    OneDrive: { eventKey: 'One_Convert', label: 'One_Convert', category: 'ADDIN', action: 'ADDIN_One_Convert'},
  },
  combine: {
    SharePoint: { eventKey: 'Share_Combine', label: 'Share_Combine', category: 'ADDIN', action: 'ADDIN_Share_Combine'},
    OneDrive: { eventKey: 'One_Combine', label: 'One_Combine', category: 'ADDIN', action: 'ADDIN_One_Combine'},
  },
  export: {
    SharePoint: { eventKey: 'Share_Export', label: 'Share_Export', category: 'ADDIN', action: 'ADDIN_Share_Export'},
    OneDrive: { eventKey: 'One_Export', label: 'One_Export', category: 'ADDIN', action: 'ADDIN_One_Export'},
  },
  organize: {
    SharePoint: { eventKey: 'Share_Organize', label: 'Share_Organize', category: 'ADDIN', action: 'ADDIN_Share_Organize'},
    OneDrive: { eventKey: 'One_Organize', label: 'One_Organize', category: 'ADDIN', action: 'ADDIN_One_Organize'},
  },
  signInPopUp: {
    SharePoint: { eventKey: 'Share_Sign-in_Pop-up', label: 'Share_Sign-in_Pop-up', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-in_Pop-up'},
  },
  signInSuccessful: {
    SharePoint: { eventKey: 'Share_Sign-in_successful', label: 'Share_Sign-in_successful', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-in_successful'},
  },
  signInInterrupted: {
    SharePoint: { eventKey: 'Share_Sign-in_interrupted', label: 'Share_Sign-in_interrupted', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-in_interrupted'},
  },
  signUpPopUp: {
    SharePoint: { eventKey: 'Share_Sign-up_Pop-up', label: 'Share_Sign-up_Pop-up', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-up_Pop-up'},
  },
  signUpSuccessful: {
    SharePoint: { eventKey: 'Share_Sign-up_create_my_account_successful', label: 'Share_Sign-up_create_my_account_successful', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-up_create_my_account_successful'},
  },
  signUpFailed: {
    SharePoint: { eventKey: 'Share_Sign-up_create_my_account_failed', label: 'Share_Sign-up_create_my_account_failed', category: 'ADDIN_Conversion', action: 'ADDIN_Share_Sign-up_create_my_account_failed'},
  },
  yearlyFreeTrial: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Yearly_Free_Trial_Submit', label: 'Share_Subscribe_Online_Yearly_Free_Trial_Submit', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Yearly_Free_Trial_Submit'},
  },
  yearlyFreeTrialSuccessful: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Yearly_Free_Trial_Successful', label: 'Share_Subscribe_Online_Yearly_Free_Trial_Successful', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Yearly_Free_Trial_Successful'},
  },
  yearlyFreeTrialFailed: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Yearly_Free_Trial_Failed', label: 'Share_Subscribe_Online_Yearly_Free_Trial_Failed', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Yearly_Free_Trial_Failed'},
  },
  monthlyFreeTrial: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Monthly_Free_Trial_Submit', label: 'Share_Subscribe_Online_Monthly_Free_Trial_Submit', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Monthly_Free_Trial_Submit'},
  },
  monthlyFreeTrialSuccessful: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Monthly_Free_Trial_Successful', label: 'Share_Subscribe_Online_Monthly_Free_Trial_Successful', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Monthly_Free_Trial_Successful'},
  },
  monthlyFreeTrialFailed: {
    SharePoint: { eventKey: 'Share_Subscribe_Online_Monthly_Free_Trial_Failed', label: 'Share_Subscribe_Online_Monthly_Free_Trial_Failed', category: 'ADDIN_Subscription', action: 'ADDIN_Share_Subscribe_Online_Monthly_Free_Trial_Failed'},
  }
}